module.exports = __webpack_public_path__ + "assets/img/jd4.16ec5457.jpg";